const state = {
    orderInfo: {},
    parkinglotId: "",
    doorId: "",
    openId: "",
    buyId: "",
    currentPath: "",
    parkrec: {},
    parkingInfo: {},
    // 优惠券扣除金额
    couponFee: undefined,
    lastPlateno: "",
    // 区域Id
    areaId: "",
    isNotification: false,
    keyTopOrderNo: undefined,
    parkRecId: undefined, //出口扫码科拓对接判断走拿个订单接口

    //停车券
    checkedParkingLotId: "",
    taskId: '',
    userPhone: "",
    userOpenid: "",
    orderSn: '',
    resultOrderSn:"",
    receiptOrderSnObj: {},
    receiptParkinglotId: '',
    totalPrice: 0,
    businessIds: [],
    clickMerRecord: false,
    interfaceManner: undefined,
    keyTopInImgUrl: undefined,
    isCardPay: undefined,
    receiptInfo: {},
    orderSnList: {},

    //安泊广告
    isOpenAdvertising: undefined,
    abParkId: undefined,
    abShow: false,
};

export default state
